module.exports = __webpack_public_path__ + "img/Image-leaf.b8540867.svg";